import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { ThemeProvider } from "@/contexts/ThemeContext";

import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import GalleryPage from "@/pages/GalleryPage";
import VideosPage from "@/pages/VideosPage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";

import AdminLayout from "@/components/admin/AdminLayout";
import LoginPage from "@/pages/admin/LoginPage";
import ForgotPasswordPage from "@/pages/admin/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/admin/ResetPasswordPage";
import ChangePasswordPage from "@/pages/admin/ChangePasswordPage";
import DashboardPage from "@/pages/admin/DashboardPage";
import ProjectsPage from "@/pages/admin/ProjectsPage";
import GalleryAdminPage from "@/pages/admin/GalleryAdminPage";
import VideosAdminPage from "@/pages/admin/VideosAdminPage";
import InquiriesAdminPage from "@/pages/admin/InquiriesAdminPage";
import TestimonialsAdminPage from "@/pages/admin/TestimonialsAdminPage";
import UsersAdminPage from "@/pages/admin/UsersAdminPage";
import SettingsPage from "@/pages/admin/SettingsPage";
import SeoPage from "@/pages/admin/SeoPage";
import AnalyticsPage from "@/pages/admin/AnalyticsPage";
import InstagramPage from "@/pages/admin/InstagramPage";

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <SettingsProvider>
                    <div className="App">
                        <BrowserRouter>
                            <Routes>
                                {/* Public */}
                                <Route element={<Layout />}>
                                    <Route path="/" element={<HomePage />} />
                                    <Route path="/gallery" element={<GalleryPage />} />
                                    <Route path="/videos" element={<VideosPage />} />
                                    <Route path="/services" element={<ServicesPage />} />
                                    <Route path="/about" element={<AboutPage />} />
                                    <Route path="/contact" element={<ContactPage />} />
                                </Route>

                                {/* Admin auth (no shell) */}
                                <Route path="/admin/login" element={<LoginPage />} />
                                <Route path="/admin/forgot-password" element={<ForgotPasswordPage />} />
                                <Route path="/admin/reset-password" element={<ResetPasswordPage />} />

                                {/* Admin shell */}
                                <Route path="/admin" element={<AdminLayout />}>
                                    <Route index element={<DashboardPage />} />
                                    <Route path="projects" element={<ProjectsPage />} />
                                    <Route path="gallery" element={<GalleryAdminPage />} />
                                    <Route path="videos" element={<VideosAdminPage />} />
                                    <Route path="inquiries" element={<InquiriesAdminPage />} />
                                    <Route path="testimonials" element={<TestimonialsAdminPage />} />
                                    <Route path="instagram" element={<InstagramPage />} />
                                    <Route path="users" element={<UsersAdminPage />} />
                                    <Route path="settings" element={<SettingsPage />} />
                                    <Route path="seo" element={<SeoPage />} />
                                    <Route path="analytics" element={<AnalyticsPage />} />
                                    <Route path="change-password" element={<ChangePasswordPage />} />
                                </Route>
                            </Routes>
                        </BrowserRouter>
                        <Toaster richColors position="top-right" />
                    </div>
                </SettingsProvider>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
